import { Chip, Tooltip, Typography, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import type { Lesson } from '@/types'
import { formatLessonTimeRange } from '@/utils/date'

type LessonRescheduledChipProps = {
  lesson: Pick<
    Lesson,
    | 'was_rescheduled'
    | 'original_planned_start_at'
    | 'planned_end_at'
    | 'last_reschedule_reason'
  >
}

export function LessonRescheduledChip({ lesson }: LessonRescheduledChipProps) {
  const { t } = useTranslation()

  if (!lesson.was_rescheduled) {
    return null
  }

  const originalLabel = lesson.original_planned_start_at
    ? formatLessonTimeRange(lesson.original_planned_start_at, null)
    : null
  const reason = lesson.last_reschedule_reason?.trim()

  const tooltip = (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, maxWidth: 320 }}>
      <Typography variant="caption" fontWeight={700}>
        {t('lessons.rescheduleInfoTitle', 'Урок перенесён')}
      </Typography>
      {originalLabel && (
        <Typography variant="caption">
          {t('lessons.rescheduleOriginalDate', 'Изначально запланирован')}: {originalLabel}
        </Typography>
      )}
      {reason && (
        <Typography variant="caption">
          {t('lessons.rescheduleReasonLabel', 'Причина переноса')}: {reason}
        </Typography>
      )}
      {!originalLabel && !reason && (
        <Typography variant="caption">{t('lessons.rescheduled', 'Перенесён')}</Typography>
      )}
    </Box>
  )

  return (
    <Tooltip title={tooltip} arrow slotProps={{ tooltip: { sx: { maxWidth: 360 } } }}>
      <Chip size="small" label={t('lessons.rescheduled', 'Перенесён')} color="info" variant="outlined" />
    </Tooltip>
  )
}
